import React from "react";
import { fmtDate, fmtDateFromNow } from "../../../../../src/js/polaris/formatters/date";
import { ToolTip } from "../tooltip";

interface DateDisplayProps {
  date: string; // ISO8601 date string
  variant?: DateDisplayVariant;
  hoverForRelative?: boolean;
  inline?: boolean;
}

export const enum DateDisplayVariant {
  MEDIUM = "ll",
  FULL = "YYYY-MM-DD h:mm:ss a",
  FROM_NOW = "from_now",
}

const DateDisplay = ({
  date,
  variant = DateDisplayVariant.MEDIUM,
  hoverForRelative = false,
  inline = false,
}: DateDisplayProps) => {
  const absDateFmt = fmtDate(
    date,
    variant !== DateDisplayVariant.FROM_NOW ? variant : DateDisplayVariant.MEDIUM,
  );
  const relDateFmt = fmtDateFromNow(date);
  const innerSpan = (
    <span>{variant === DateDisplayVariant.FROM_NOW ? relDateFmt : absDateFmt}</span>
  );
  const tooltipText = variant === DateDisplayVariant.FROM_NOW ? absDateFmt : relDateFmt;

  if (hoverForRelative) {
    return (
      <ToolTip text={tooltipText} inline={inline}>
        {innerSpan}
      </ToolTip>
    );
  } else {
    return innerSpan;
  }
};

export default DateDisplay;
